(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/modules/tickets-giftshop/assets/react/shared-components/products/reducer.js') >= 0) return;  svs.modules.push('/modules/tickets-giftshop/assets/react/shared-components/products/reducer.js');
"use strict";


const _svs$tickets_giftshop = svs.tickets_giftshop.data,
  giftableGames = _svs$tickets_giftshop.giftableGames,
  cmsProducts = _svs$tickets_giftshop.cmsProducts;
const initProductsState = {
  jupiterProducts: giftableGames,
  products: cmsProducts
};
function reducer() {
  let state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : initProductsState;
  let action = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
  switch (action.type) {
    default:
      return state;
  }
}
svs.tickets_giftshop.products.reducer = reducer;

 })(window);